import { useState } from "react";
import { useRouter } from "next/router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Menu, message } from "antd";
import SiteLayout from "~/components/layout/SiteLayout";
import GroupNavs from "~/components/groups/GroupNavs";
import GroupApplicationForm from "~/components/groups/GroupApplicationForm";
import { showAppMessage, requireAuth } from "~/redux/actions/app";
import { createGroupApplication } from "~/services/groups";

const NewGroupPage = (props) => {
  const router = useRouter();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (formData) => {
    if (!props.token) {
      props.requireAuth({ skipRefresh: true });
      return;
    }

    try {
      const submitFormData = new FormData();
      submitFormData.append("name", formData.name);
      submitFormData.append("description", formData.description);
      submitFormData.append("member_count", formData.member_count);
      submitFormData.append("ele", formData.ele);
      submitFormData.append("paid", formData.paid || false);
      submitFormData.append("kind", formData.kind);
      submitFormData.append("group_category_id", formData.group_category_id);

      if (formData.logoFile) {
        submitFormData.append("logo", formData.logoFile);
      }

      const isQrcodeType = formData.kind === "wechat" || formData.kind === "QQ";
      if (isQrcodeType && formData.qrcodeFile) {
        submitFormData.append("qrcode", formData.qrcodeFile);
      } else if (!isQrcodeType && formData.link) {
        submitFormData.append("link", formData.link);
      }

      setSubmitting(true);
      const createdGroup = await createGroupApplication(
        props.token,
        submitFormData
      );
      props.showAppMessage("群组申请提交成功", "success");
      router.push(`/groups/managed/${createdGroup.id}`);
    } catch (err) {
      throw err;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SiteLayout
      pageTitle="申请/推荐收录"
      pageSider={<GroupNavs active="new" />}
      siderOptions={{
        position: "left",
        size: "sm",
      }}
    >
      <Card>
        <Menu
          mode="horizontal"
          selectedKeys={["new"]}
          style={{ marginBottom: 24 }}
        >
          <Menu.Item key="new">申请/推荐收录</Menu.Item>
        </Menu>

        <GroupApplicationForm
          onSubmit={handleSubmit}
          loading={submitting}
        />
      </Card>
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppMessage,
      requireAuth,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewGroupPage);
